/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: VacationPolicyWithRelations, schemaOptions: { includeRelations: true })
 */
export interface VacationPolicyWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    workerType: VacationPolicyWithRelations.WorkerTypeEnum;
    yearsFrom: number;
    yearsTo?: number;
    vacationDays: number;
    articleReference?: string;
    weeklyIncrement?: number;
}
export namespace VacationPolicyWithRelations {
    export type WorkerTypeEnum = 'normal' | 'sindicalizado' | 'especial';
    export const WorkerTypeEnum = {
        Normal: 'normal' as WorkerTypeEnum,
        Sindicalizado: 'sindicalizado' as WorkerTypeEnum,
        Especial: 'especial' as WorkerTypeEnum
    };
}


